var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service';
// import CollectionCaseInfo from '~/pages/collection-execution/collection-case-info.vue';
import CollectionAddList from '~/components/collection-execution/collection-add-list.vue';
import CollectionActionArea from '~/components/collection-execution/collection-action-area.vue';
import CollectionHistoryInfo from '~/components/collection-execution/collection-history-info.vue';
import CollectionHotkey from '~/components/collection-execution/collection-hotkey.vue';
import OutsourceCaseInfo from '~/pages/outsource-manage/outsource-case-info.vue';
var OutsourceDetail = /** @class */ (function (_super) {
    __extends(OutsourceDetail, _super);
    function OutsourceDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showCaseList = false;
        _this.topInfo = {};
        return _this;
    }
    /**
     * 初始化
     */
    OutsourceDetail.prototype.ready = function () {
        var _this = this;
        // 注册点击事件
        document.addEventListener('click', function (event) {
            var target = event.target;
            // const caseElement = document.getElementById("divCaseList");
            var hotKeyElement = document.getElementById('divHotKey');
            // if (caseElement && !caseElement.contains(target)) {
            //   this.showLeftCaseList = false;
            // }
            if (hotKeyElement && !hotKeyElement.contains(target)) {
                _this.showCaseList = false;
            }
        });
    };
    OutsourceDetail.prototype.created = function () {
        var _this = this;
        this.caseOperatorPageService
            .topInfo({ caseId: this.$route.params.caseId })
            .subscribe(function (data) {
            _this.topInfo = data;
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], OutsourceDetail.prototype, "caseOperatorPageService", void 0);
    OutsourceDetail = __decorate([
        Component({
            components: {
                // CollectionCaseInfo,
                CollectionAddList: CollectionAddList,
                CollectionActionArea: CollectionActionArea,
                CollectionHistoryInfo: CollectionHistoryInfo,
                CollectionHotkey: CollectionHotkey,
                OutsourceCaseInfo: OutsourceCaseInfo
            },
        })
    ], OutsourceDetail);
    return OutsourceDetail;
}(Vue));
export default OutsourceDetail;
